import React from 'react';
import styled from 'styled-components';
import { COLORS, FONTS } from '../../constants';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  background?: string;
  color?: string;
  fontSize?: number;
  fontWeight?: number;
  lineHeight?: number;
  fontFamily?: string;
  borderRadius?: number;
  border?: React.CSSProperties['border'];
  width?: number | string;
  height?: number;
  icon?: React.ReactNode;
  margin?: string;
}

export const Button: React.FC<ButtonProps> = ({
  background = COLORS.MAIN_RED,
  color = COLORS.WHITE,
  fontSize = 16,
  fontWeight = 500,
  lineHeight,
  fontFamily = FONTS.SUBTITLE,
  width = 100,
  height = 55,
  borderRadius = 0,
  border,
  margin = '0 auto',
  icon,
  children,
  ...props
}) => {
  return (
    <Btn
      {...props}
      $background={background}
      $width={width}
      $height={height}
      $margin={margin}
      $borderRadius={borderRadius}
      $border={border}
      $hasIcon={!!icon}
    >
      <ButtonText
        $color={color}
        $fontSize={fontSize}
        $fontWeight={fontWeight}
        $lineHeight={lineHeight}
        $fontFamily={fontFamily}
      >
        {children}
      </ButtonText>
      {icon && <IconWrapper>{icon}</IconWrapper>}
    </Btn>
  );
};

const Btn = styled.button<{
  $background?: string;
  $width?: number | string;
  $height?: number;
  $borderRadius?: number;
  $border?: React.CSSProperties['border'];
  $margin?: string;
  $hasIcon?: boolean;
}>`
  background-color: ${props => props.$background};
  width: ${props =>
    typeof props.$width === 'number' ? `${props.$width}px` : `${props.$width}`};
  height: ${props => `${props.$height}px`};
  border-radius: ${props => `${props.$borderRadius}px`};
  ${props => (props.$border ? `border: ${props.$border};` : 'border: none;')}
  display: flex;
  align-items: center;
  justify-content: ${props => (props.$hasIcon ? 'space-between' : 'center')};
  gap: 8px;
  cursor: pointer;
  padding: 0 28px;
  margin: ${props => props.$margin};
  transition: 0.2s;
  opacity: ${props => (props.disabled ? 0.4 : 1)};
  &:hover {
    opacity: ${props => (props.disabled ? 0.4 : 0.85)};
  }
`;

const ButtonText = styled.span<{
  $color?: string;
  $fontSize?: number;
  $fontWeight?: number;
  $lineHeight?: number;
  $fontFamily?: string;
}>`
  color: ${props => props.$color};
  font-size: ${props => `${props.$fontSize}px`};
  font-weight: ${props => props.$fontWeight};
  ${props => props.$lineHeight && `line-height: ${props.$lineHeight}px;`}
  font-family: ${props => props.$fontFamily};
`;

const IconWrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: inherit;
`;
